import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'project-create-importer-upload-flow.select-source-screen.heading',
		defaultMessage: 'Import data into Jira',
		description: 'page heading',
	},
	pageDescription: {
		id: 'project-create-importer-upload-flow.select-source-screen.page-description',
		defaultMessage:
			'Import from any app into a new business or software project. Your imports will not affect current issues and users in Jira.',
		description: 'Helper text to let users know this importer',
	},
});
